import { FC } from 'react';
import EditRoadSectionGestionaryModal from './Edit/EditRoadSectionGestionaryModal';
import EditRoadSectionYearModal from './Edit/EditRoadSectionYearModal';
import EditRoadSectionCategoryModal from './Edit/EditRoadSectionCategoryModal';
import EditRoadSectionTraficPLModal from './Edit/EditRoadSectionTraficPLModal';
import EditRoadSectionWidthModal from './Edit/EditRoadSectionWitdhModal';
import EditRoadSectionRoadTypeModal from './Edit/EditRoadSectionRoadTypeModal';
import EditRoadSectionUrbanModal from './Edit/EditRoadSectionUrbanModal';
import GenerateReferenceModal from './GenerateReferenceModal';

export const ReferenceListModals: FC = () => {
    return (
        <>
            <EditRoadSectionGestionaryModal />
            <EditRoadSectionCategoryModal />
            <EditRoadSectionTraficPLModal />
            <EditRoadSectionWidthModal />
            <EditRoadSectionRoadTypeModal />
            <EditRoadSectionUrbanModal />
            <EditRoadSectionYearModal />
            <GenerateReferenceModal />
        </>
    );
};
